// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.doa-board {
  width: 1150px;
  height: 250px;
  margin-right: 15px;
  margin-left: 25px;
  margin-top: 1px;
}

.bot-table-response-doa {
  /* overflow-x: scroll; */
  width: fit-content;
}

.Heading-Doa {
  color: #FFFFFF;
  font-family: 'Graphik';
  font-weight: 350;
  font-size: 11px;
  /* margin-left: 20px; */
  /* margin-left: 25px;
    margin-top: 15px; */
  padding: 5px 20px;
}

.info-icon-doa {
  float: inline-end;
  margin-bottom: 10px;
  margin-right: 5px;
  /* margin-left: 99%;
    margin-bottom: 10px;
    margin-top: -25px; */
  display: flex;
}

.main-doa-container {
  width: 1150px;
  height: 500px;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #8d97dac5;
  margin-top: 10px;
  margin-left: 25px;
  background-color: rgba(39, 40, 75, 1);
}

.doa-icon {
  width: 30px;
  margin-left: 10px;
  cursor: pointer;
}

.doa-container {
  min-height: 100vh;
  color: rgba(255, 255, 255, 1);
  margin-top: 15px;
  margin-left: 10px;
  margin-bottom: 20px;
  min-width: 113%;
  overflow-y: auto;
}

.doa-hide-scroll {
  /* width: 1100px; */
  height: 550px;
  /* box-sizing: content-box; */
  /* overflow-y: hidden; */
}

.analysis-head {
  color: #FFFFFF;
  font-family: 'Graphik';
  font-weight: 500;
  font-size: 14px;
  margin-top: 10px;
  margin-left: 10px;
  padding-right: 20px;
  padding-bottom: 10px;
  padding-top: 10px;
  border-right-style: solid;
  border-width: 1px;
  border-color: #8d97dac5;

}

.analysis-header {
  color: #FFFFFF;
  font-family: 'Graphik';
  font-weight: 500;
  font-size: 14px;
  margin-top: 10px;
  margin-left: 10px;
  padding-right: 20px;
  padding-bottom: 5px;
  padding-top: 15px;

}

.analysis-header-rig {
  color: #FFFFFF;
  font-family: 'Graphik';
  font-weight: 500;
  font-size: 14px;
  margin-top: 10px;
  margin-left: 10px;
  padding-right: 20px;
  padding-bottom: 5px;
  padding-top: 15px;
  width: 82vw;
}

.feature {
  display: flex;
  margin-left: 20px;
  margin-top: 5px;
}

.plus-button {
  width: 27px;
  margin-left: 10px;
  cursor: pointer;
}

.filter-button {
  width: 22px;
  margin-left: 15px;
}

.modalcontent {
  margin: auto;
  background: rgb(255, 255, 255);
  width: 50%;
  padding: 5px;
}

/* .my-popup-arrow {
    color: rgb(255, 255, 255);
  }
  [role='tooltip'].my-popup-content {
    width: 200px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 0px 3px;
  }
  
  .my-popup-overlay {
    background: rgba(0, 0, 0, 0.5);
  }
  [data-popup='tooltip'].my-popup-overlay {
    background: transparent;
  } */


.plus-icon-doa {
  cursor: pointer;
  height: 2px;
  width: 1%;
  text-align: center;
  padding-top: 20px;
  /* margin-left: 10px; */
}

.modal-backdrop {
  background-color: transparent;
}

.modal-doa {
  background-color: rgba(30, 32, 61, 1);
  border: 1px solid #6B5CD1;
  border-radius: 8px;
}

.modalHeader {
  background-color: #747BA9;
}

.analysis-backdrop {
  background-color: rgba(39, 40, 75, 1);
  margin-top: -9px;
  border-radius: 8px;
}

.analysis-head2 {
  color: #FFFFFF;
  font-family: 'Graphik';
  font-weight: 500;
  font-size: 14px;
  margin-top: 10px;
  padding: 10px;
  margin-left: 25px;
}

.close-icon-doa {
  font-size: 24px;
  position: absolute;
  cursor: pointer;
  color: blueviolet;
  background-color: transparent;
  border: none;
  border-radius: 5px;
  width: 23px;
  float: left;
  margin-left: 250px;
}

.radio-buttons {
  margin-top: 10px;
}

.doa-button {
  margin-top: 20px;
}

.form-data-doa {
  background-color: #747BA9;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #b0b8ebc5;
  text-align: left;
  padding: 5px;
  margin-top: 8px;
  font-weight: 300;
  font-size: 14px;
  font-style: italic;
  width: 390px;
  height: 35px;
  color: white;
}

.form-data-doa::placeholder {
  color: rgba(255, 255, 255, 1);
}

.upload-text {
  color: #FFFFFF;
  font-family: 'Graphik';
  font-weight: 300;
  font-size: 13px;
  line-height: 20px;
  word-wrap: normal;
  width: 200px;
}

.uploadicon {
  width: 20px;
  margin-left: 7px;
}

.describe {
  margin-top: 7px;
  color: #FFFFFF;
  font-family: 'Graphik';
  font-weight: 300;
  font-size: 14px;
  text-wrap: wrap;
  width: 400px;
}

.analysis-head2 {
  color: #FFFFFF;
  font-family: 'Graphik';
  font-weight: 500;
  font-size: 14px;
  margin-top: 10px;
  padding-bottom: 10px;
  padding-top: 10px;
  margin-left: 10px;
}

.generate-label-doa {
  color: aliceblue;
  font-family: 'Graphik';
  font-weight: 500;
  font-size: 14px;
  margin-top: 10px;
}

.modal-content-doa {
  display: flex;
  margin-left: 5px;
  flex-direction: column;
  margin-left: 25px;
  margin-right: 10px;
}

.uploadbox-doa {
  background-color: rgba(39, 40, 75, 1);
  border-style: solid;
  border-width: 1px;
  border-color: #8d97dac5;
  height: 60px;
  width: 350px;
  margin-top: 35px;
  border-radius: 5px;
}

.processe-doa-button {
  border-radius: 15px;
  margin-left: 240px;
  background-color: rgba(107, 92, 209, 1);
  color: rgba(255, 255, 255, 1);
  text-align: center;
  text-decoration: none;
  border: none;
  font-size: 15px;
  width: 110px;
  height: 35px;
  float: right;
  margin: 20px 20px 20px 0px;
  cursor: pointer;
}

.drill-card {
  background-color: #3C4069;
  border: 1px solid #747BA9;
  border-radius: 8px;
  min-width: 260px;
  height: 115px;
  margin: 10px;
}

.drill-card-body {
  padding: 15px 10px;
}

.view-report {
  width: auto;
  float: right;
  cursor: pointer;
  background-color: rgba(107, 92, 209, 1);
  color: rgba(255, 255, 255, 1);
  font-family: Graphik;
  font-size: 12px;
  font-weight: 400;
  padding: 2% 4%;
  border: none;
  border-radius: 10dvh;
  margin-top: -20px;
}

.report-icon {
  width: 20px;
}

.status-drill {
  max-width: fit-content;
  margin-top: -6px;
  padding: 1% 3%;
  height: fit-content;
  background-color: rgba(36, 182, 0, 1);
  /* rgba(216, 172, 27, 1) */
  color: rgba(255, 255, 255, 1);
  font-family: Graphik;
  font-size: 11px;
  font-weight: 300;
  border: none;
  border-radius: 8dvh;
}

.drill-header {
  color: aliceblue;
  font-family: 'Graphik';
  font-weight: 600;
  font-size: 11px;
  line-height: 5px;
}

.drill-body {
  color: aliceblue;
  font-family: 'Graphik';
  font-weight: 400;
  font-size: 12px;
  line-height: 5px;
}

.drillanalysis-report {
  padding-left: 20px;
  padding-top: 10px;
  display: flex;
  flex-wrap: wrap;
}

.rig-panel {
  background-color: #2A2D4E;
  border: 1px solid #747BA9;
  border-radius: 18px;
  width: 198vh;
  margin-top: 20px;
  /* min-height: 600px;
  max-height: 900px; */
  height: auto;
  /* overflow-y: auto; */
  margin-left: 15px;
}

.rig {
  background-color: #3C4069;
  border-radius: 8px;
  min-width: 40vh;
  /* width: auto; */
  height: 140px;
  margin: 10px;
  cursor: pointer;
}

.rig-company {
  padding-left: 10px;
  padding-top: 20px;
  padding-bottom: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.rig-contract {
  padding-left: 10px;
  padding-top: 20px;
  padding-bottom: 10px;
  border-top: 1px solid #747BA9;
}

.rig-box {
  display: flex;
  flex-wrap: wrap;
}

.rig-top-header {
  color: aliceblue;
  font-family: 'Graphik';
  font-weight: 400;
  font-size: 14px;
  line-height: 10px;
  margin-left: 10px;
}

.rig-header {
  color: aliceblue;
  font-family: 'Graphik';
  font-weight: 400;
  font-size: 14px;
  line-height: 15px;
}

.rig-header1 {
  color: aliceblue;
  font-family: 'Graphik';
  font-weight: 400;
  font-size: 12px;
  line-height: 5px;
}

.rig-body {
  color: aliceblue;
  font-family: 'Graphik';
  font-weight: 350;
  font-size: 11px;
  white-space: normal;
  word-wrap: break-word;
}

p.rig-body {
  line-height: 6px;
}

ul.rig-body {
  list-style-type: none;
  line-height: 13px;
  margin-left: 0;
  padding: 0;
}

.rig-severity {
  height: 10px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  /* background-color: red; */
  /* margin-left: -15px; */
}

.modal-overlay-doa {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
  top: 0;
  left: 0;
}



/* Rigdetails css */
.icon-doa1 {
  float: right;
}

.icon-doa {
  float: right;
  margin-left: 5%;
  display: flex;
}
.icon-doa-rig {
  display: flex;
  margin-left: 50px;
}

.icon-copy-doa {
  width: 13px;
}

.icon-share-doa {
  margin-right: 20px;
  width: 15px;
}

.icon-back-doa1 {
  margin-right: 15px;
  width: 20px;
}

.icon-back-doa {
  width: 20px;
  margin-right: 15px;
}

.rig-details-panel {
  background-color: rgba(0, 0, 0, 0.1);
  width: 1150px;
  height: 900px;
  margin-left: 20px;
  margin-top: 15px;
}

.rig-details {
  padding-top: 20px;
  padding-bottom: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.rig-details-box {
  background-color: rgba(39, 40, 75, 1);
  color: aliceblue;
  font-family: 'Graphik';
  font-weight: 400;
  font-size: 14px;
  line-height: 10px;
  border: 1px solid rgba(116, 123, 169, 1);
  /* margin: 0px 10px 10px 5px; */
  border-radius: 10px;
}


.rig-details-box::-webkit-scrollbar {
  width: 5px;
}

.rig-details-box::-webkit-scrollbar-thumb {
  border-radius: 10px;
}

/* .rig-details-box::-webkit-scrollbar-track-piece{
  height: 50px;

} */

.rig-details-header {
  background-color: rgba(60, 64, 105, 1);
  border-bottom: 1px solid rgba(87, 95, 142, 1);
  color: aliceblue;
  font-family: 'Graphik';
  font-weight: 400;
  font-size: 14px;
  line-height: 10px;
  height: 30px;
  padding: 10px;
  margin-left: -12px;
  margin-right: -12px;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  margin-bottom: 10px;
}

.flex-cont {
  display: flex;
}



.flex-cont-row {
  display: flex;
  flex-direction: column;
}

.rig-details-body {
  color: aliceblue;
  font-family: 'Graphik';
  font-weight: 300;
  font-size: 11px;
  line-height: 5px;
}


.custom-file-upload {
  display: inline-block;
  position: relative;
  font-family: Arial, sans-serif;
  /* overflow: hidden; */
  margin-right: 4px;
  margin-top: 10px;
}

.custom-file-upload input[type="file"] {
  font-size: 100px;
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
}

.custom-file-upload span {
  padding: 6px 12px;
  cursor: pointer;
  border-radius: 10px;
  border: 1px solid rgba(116, 123, 169, 1);
  color: rgba(255, 255, 255, 1);
  width: 100px;
  height: 40px;
  margin-left: 60px;
  background-color: rgba(116, 123, 169, 0.3);
}

.custom-file-upload:hover span {
  background: rgba(116, 123, 169, 1);
}

.upload-button {
  border-radius: 10px;
  border: 1px solid rgba(116, 123, 169, 1);
  color: rgba(255, 255, 255, 1);
  /* width:100px;
  height:40px; */
  margin-left: 60px;
  background-color: rgba(116, 123, 169, 0.3);
}

.loader-c {
  display: flex;
  margin-left: 150px;
  justify-content: center;
  align-items: center;
  height: 40px;
}

.dot-cq-doa {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  display: inline-block;
  animation: bounce 1.4s infinite ease-in-out;
}

.red-c-doa {
  background-color: red;
  animation-delay: -0.32s;
}

.green-c-doa {
  background-color: green;
  animation-delay: -0.16s;
}

.blue-c-doa {
  background-color: blue;

}

.tick-circle {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: green;
  position: relative;
  top: 10%;
  left: 4%;
}

.tick-circle::before {
  content: '\\2713';
  /* Unicode character for a checkmark */
  font-size: 10px;
  color: white;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.table-doa1 {
  border-collapse: collapse;
  border: 1px solid rgba(87, 95, 142, 1);
  border-radius: 20px;
  /* width: 100%; */
}

.table-doa1 th {
  border: 1px solid #575F8E;
  padding: 20px;
  text-align: center;
  background-color: #3C4069;
  width: fit-content;
}

.table-doa1 td {
  border: 1px solid #575F8E;
  padding: 8px;
  text-align: left;
}

.table-doa1 tr {
  width: 100%;
}

.table-doa1 tbody tr:hover {
  background-color: rgba(87, 95, 142, 0.452);
  /* Custom color for hover effect */
}

.even-row {
  background-color: #27284B
}

.odd-row {
  background-color: #202342
}

/* @media (max-width: 600px) {
    .table-doa1 th,
    .table-doa1 td {
      display: block;
      width: 100%;
      box-sizing: border-box;
    }
  } */
.search-rig {
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #8d97dac5;
  height: 30px;
  width: 270px;
  background-color: transparent;
  margin-top: 17px;
  margin-right: 15px;
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 400;
  padding-left: 5px;
}

.search-rig::placeholder {
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 400;
  padding: 5px;
}

.search-rig:focus {
  outline: none;
}
.search-dd {
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #8d97dac5;
  height: 30px;
  width: 270px;
  background-color: transparent;
  margin-left: 90%;
  margin-top: 17px;
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 400;
  padding-left: 5px;
}

.search-dd::placeholder {
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 400;
  padding: 5px;
}

.search-dd:focus {
  outline: none;
}

.status-dd {
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #8d97dac5;
  height: 30px;
  width: 170px;
  background-color: transparent;
  margin-left: 13px;
  margin-top: 17px;
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 400;
  padding-left: 5px;
}

.status-dd::placeholder {
  color: #FFFFFF;
  font-size: 13px;
  font-weight: 400;
  padding: 10px 5px;
}

.status-dd:focus {
  outline: none;
}

.status-dd option {
  color: white;
  background-color: #3C4069;
  border: 1px solid #747BA9;
  font-size: 12px;
  font-family: Graphik;
  font-weight: 400;
}

select option [disabled] {
  color: black;
  font-size: 12px;
  font-family: Graphik;
  font-weight: 400;
}

.icon-input {
  position: relative;
}

.icon-input input {
  padding-left: 30px;
}

.icon12 {
  position: absolute;
  left: 20px;
  top: 45%;
  transform: translateY(-50%);
}

.icon12-rig {
  position: absolute;
  left: 10px;
  top: 45%;
  transform: translateY(-50%);
}

.icon123 {
  position: absolute;
  left: 92%;
  top: 45%;
  transform: translateY(-50%);
}

.datepicker {
  padding-left: 40px;
}

.rig-panel-top {
  display: flex;
  margin-left: 10px;
}

.rig-details-panel-top {
  margin-left: 15px;
}

.icon-drilling-button{
  width: 20px;
  margin-right: 15px;
}

.date-rig{
  width: fit-content;
  padding: 5px;
  color: #FFFFFF;
  font-family: Graphik;
  font-size: 12px;
  font-weight: 355;
  border-radius: 5px;
  border: 1px solid #747BA9;
  margin-right: 15px;
  margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./src/Drilling_Operation_Assistant/Doa.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB;uBACqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB;;wBAEsB;EACtB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;EACjB,uBAAuB;;AAEzB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;;AAEnB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,UAAU;EACV,YAAY;AACd;;AAEA;;;;;;;;;;;;;KAaK;;;AAGL;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uCAAuC;EACvC,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,uCAAuC;EACvC,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,qCAAqC;EACrC,0BAA0B;EAC1B,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB;sBACoB;EACpB,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B,+BAA+B;EAC/B,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,MAAM;EACN,OAAO;AACT;;;;AAIA,mBAAmB;AACnB;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,aAAa;AACf;AACA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,wCAAwC;EACxC,+BAA+B;EAC/B,mBAAmB;AACrB;;;AAGA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;GAGG;;AAEH;EACE,sCAAsC;EACtC,6CAA6C;EAC7C,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;;;AAIA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;;AAGA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,8BAA8B;EAC9B,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,wCAAwC;EACxC,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,6BAA6B;EAC7B;gBACc;EACd,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;;AAExB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;;;;;;;KAOK;AACL;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,6BAA6B;EAC7B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":[".doa-board {\n  width: 1150px;\n  height: 250px;\n  margin-right: 15px;\n  margin-left: 25px;\n  margin-top: 1px;\n}\n\n.bot-table-response-doa {\n  /* overflow-x: scroll; */\n  width: fit-content;\n}\n\n.Heading-Doa {\n  color: #FFFFFF;\n  font-family: 'Graphik';\n  font-weight: 350;\n  font-size: 11px;\n  /* margin-left: 20px; */\n  /* margin-left: 25px;\n    margin-top: 15px; */\n  padding: 5px 20px;\n}\n\n.info-icon-doa {\n  float: inline-end;\n  margin-bottom: 10px;\n  margin-right: 5px;\n  /* margin-left: 99%;\n    margin-bottom: 10px;\n    margin-top: -25px; */\n  display: flex;\n}\n\n.main-doa-container {\n  width: 1150px;\n  height: 500px;\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 5px;\n  border-color: #8d97dac5;\n  margin-top: 10px;\n  margin-left: 25px;\n  background-color: rgba(39, 40, 75, 1);\n}\n\n.doa-icon {\n  width: 30px;\n  margin-left: 10px;\n  cursor: pointer;\n}\n\n.doa-container {\n  min-height: 100vh;\n  color: rgba(255, 255, 255, 1);\n  margin-top: 15px;\n  margin-left: 10px;\n  margin-bottom: 20px;\n  min-width: 113%;\n  overflow-y: auto;\n}\n\n.doa-hide-scroll {\n  /* width: 1100px; */\n  height: 550px;\n  /* box-sizing: content-box; */\n  /* overflow-y: hidden; */\n}\n\n.analysis-head {\n  color: #FFFFFF;\n  font-family: 'Graphik';\n  font-weight: 500;\n  font-size: 14px;\n  margin-top: 10px;\n  margin-left: 10px;\n  padding-right: 20px;\n  padding-bottom: 10px;\n  padding-top: 10px;\n  border-right-style: solid;\n  border-width: 1px;\n  border-color: #8d97dac5;\n\n}\n\n.analysis-header {\n  color: #FFFFFF;\n  font-family: 'Graphik';\n  font-weight: 500;\n  font-size: 14px;\n  margin-top: 10px;\n  margin-left: 10px;\n  padding-right: 20px;\n  padding-bottom: 5px;\n  padding-top: 15px;\n\n}\n\n.analysis-header-rig {\n  color: #FFFFFF;\n  font-family: 'Graphik';\n  font-weight: 500;\n  font-size: 14px;\n  margin-top: 10px;\n  margin-left: 10px;\n  padding-right: 20px;\n  padding-bottom: 5px;\n  padding-top: 15px;\n  width: 82vw;\n}\n\n.feature {\n  display: flex;\n  margin-left: 20px;\n  margin-top: 5px;\n}\n\n.plus-button {\n  width: 27px;\n  margin-left: 10px;\n  cursor: pointer;\n}\n\n.filter-button {\n  width: 22px;\n  margin-left: 15px;\n}\n\n.modalcontent {\n  margin: auto;\n  background: rgb(255, 255, 255);\n  width: 50%;\n  padding: 5px;\n}\n\n/* .my-popup-arrow {\n    color: rgb(255, 255, 255);\n  }\n  [role='tooltip'].my-popup-content {\n    width: 200px;\n    box-shadow: rgba(0, 0, 0, 0.16) 0px 0px 3px;\n  }\n  \n  .my-popup-overlay {\n    background: rgba(0, 0, 0, 0.5);\n  }\n  [data-popup='tooltip'].my-popup-overlay {\n    background: transparent;\n  } */\n\n\n.plus-icon-doa {\n  cursor: pointer;\n  height: 2px;\n  width: 1%;\n  text-align: center;\n  padding-top: 20px;\n  /* margin-left: 10px; */\n}\n\n.modal-backdrop {\n  background-color: transparent;\n}\n\n.modal-doa {\n  background-color: rgba(30, 32, 61, 1);\n  border: 1px solid #6B5CD1;\n  border-radius: 8px;\n}\n\n.modalHeader {\n  background-color: #747BA9;\n}\n\n.analysis-backdrop {\n  background-color: rgba(39, 40, 75, 1);\n  margin-top: -9px;\n  border-radius: 8px;\n}\n\n.analysis-head2 {\n  color: #FFFFFF;\n  font-family: 'Graphik';\n  font-weight: 500;\n  font-size: 14px;\n  margin-top: 10px;\n  padding: 10px;\n  margin-left: 25px;\n}\n\n.close-icon-doa {\n  font-size: 24px;\n  position: absolute;\n  cursor: pointer;\n  color: blueviolet;\n  background-color: transparent;\n  border: none;\n  border-radius: 5px;\n  width: 23px;\n  float: left;\n  margin-left: 250px;\n}\n\n.radio-buttons {\n  margin-top: 10px;\n}\n\n.doa-button {\n  margin-top: 20px;\n}\n\n.form-data-doa {\n  background-color: #747BA9;\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 5px;\n  border-color: #b0b8ebc5;\n  text-align: left;\n  padding: 5px;\n  margin-top: 8px;\n  font-weight: 300;\n  font-size: 14px;\n  font-style: italic;\n  width: 390px;\n  height: 35px;\n  color: white;\n}\n\n.form-data-doa::placeholder {\n  color: rgba(255, 255, 255, 1);\n}\n\n.upload-text {\n  color: #FFFFFF;\n  font-family: 'Graphik';\n  font-weight: 300;\n  font-size: 13px;\n  line-height: 20px;\n  word-wrap: normal;\n  width: 200px;\n}\n\n.uploadicon {\n  width: 20px;\n  margin-left: 7px;\n}\n\n.describe {\n  margin-top: 7px;\n  color: #FFFFFF;\n  font-family: 'Graphik';\n  font-weight: 300;\n  font-size: 14px;\n  text-wrap: wrap;\n  width: 400px;\n}\n\n.analysis-head2 {\n  color: #FFFFFF;\n  font-family: 'Graphik';\n  font-weight: 500;\n  font-size: 14px;\n  margin-top: 10px;\n  padding-bottom: 10px;\n  padding-top: 10px;\n  margin-left: 10px;\n}\n\n.generate-label-doa {\n  color: aliceblue;\n  font-family: 'Graphik';\n  font-weight: 500;\n  font-size: 14px;\n  margin-top: 10px;\n}\n\n.modal-content-doa {\n  display: flex;\n  margin-left: 5px;\n  flex-direction: column;\n  margin-left: 25px;\n  margin-right: 10px;\n}\n\n.uploadbox-doa {\n  background-color: rgba(39, 40, 75, 1);\n  border-style: solid;\n  border-width: 1px;\n  border-color: #8d97dac5;\n  height: 60px;\n  width: 350px;\n  margin-top: 35px;\n  border-radius: 5px;\n}\n\n.processe-doa-button {\n  border-radius: 15px;\n  margin-left: 240px;\n  background-color: rgba(107, 92, 209, 1);\n  color: rgba(255, 255, 255, 1);\n  text-align: center;\n  text-decoration: none;\n  border: none;\n  font-size: 15px;\n  width: 110px;\n  height: 35px;\n  float: right;\n  margin: 20px 20px 20px 0px;\n  cursor: pointer;\n}\n\n.drill-card {\n  background-color: #3C4069;\n  border: 1px solid #747BA9;\n  border-radius: 8px;\n  min-width: 260px;\n  height: 115px;\n  margin: 10px;\n}\n\n.drill-card-body {\n  padding: 15px 10px;\n}\n\n.view-report {\n  width: auto;\n  float: right;\n  cursor: pointer;\n  background-color: rgba(107, 92, 209, 1);\n  color: rgba(255, 255, 255, 1);\n  font-family: Graphik;\n  font-size: 12px;\n  font-weight: 400;\n  padding: 2% 4%;\n  border: none;\n  border-radius: 10dvh;\n  margin-top: -20px;\n}\n\n.report-icon {\n  width: 20px;\n}\n\n.status-drill {\n  max-width: fit-content;\n  margin-top: -6px;\n  padding: 1% 3%;\n  height: fit-content;\n  background-color: rgba(36, 182, 0, 1);\n  /* rgba(216, 172, 27, 1) */\n  color: rgba(255, 255, 255, 1);\n  font-family: Graphik;\n  font-size: 11px;\n  font-weight: 300;\n  border: none;\n  border-radius: 8dvh;\n}\n\n.drill-header {\n  color: aliceblue;\n  font-family: 'Graphik';\n  font-weight: 600;\n  font-size: 11px;\n  line-height: 5px;\n}\n\n.drill-body {\n  color: aliceblue;\n  font-family: 'Graphik';\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 5px;\n}\n\n.drillanalysis-report {\n  padding-left: 20px;\n  padding-top: 10px;\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.rig-panel {\n  background-color: #2A2D4E;\n  border: 1px solid #747BA9;\n  border-radius: 18px;\n  width: 198vh;\n  margin-top: 20px;\n  /* min-height: 600px;\n  max-height: 900px; */\n  height: auto;\n  /* overflow-y: auto; */\n  margin-left: 15px;\n}\n\n.rig {\n  background-color: #3C4069;\n  border-radius: 8px;\n  min-width: 40vh;\n  /* width: auto; */\n  height: 140px;\n  margin: 10px;\n  cursor: pointer;\n}\n\n.rig-company {\n  padding-left: 10px;\n  padding-top: 20px;\n  padding-bottom: 10px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.rig-contract {\n  padding-left: 10px;\n  padding-top: 20px;\n  padding-bottom: 10px;\n  border-top: 1px solid #747BA9;\n}\n\n.rig-box {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.rig-top-header {\n  color: aliceblue;\n  font-family: 'Graphik';\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 10px;\n  margin-left: 10px;\n}\n\n.rig-header {\n  color: aliceblue;\n  font-family: 'Graphik';\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 15px;\n}\n\n.rig-header1 {\n  color: aliceblue;\n  font-family: 'Graphik';\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 5px;\n}\n\n.rig-body {\n  color: aliceblue;\n  font-family: 'Graphik';\n  font-weight: 350;\n  font-size: 11px;\n  white-space: normal;\n  word-wrap: break-word;\n}\n\np.rig-body {\n  line-height: 6px;\n}\n\nul.rig-body {\n  list-style-type: none;\n  line-height: 13px;\n  margin-left: 0;\n  padding: 0;\n}\n\n.rig-severity {\n  height: 10px;\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  /* background-color: red; */\n  /* margin-left: -15px; */\n}\n\n.modal-overlay-doa {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n  top: 0;\n  left: 0;\n}\n\n\n\n/* Rigdetails css */\n.icon-doa1 {\n  float: right;\n}\n\n.icon-doa {\n  float: right;\n  margin-left: 5%;\n  display: flex;\n}\n.icon-doa-rig {\n  display: flex;\n  margin-left: 50px;\n}\n\n.icon-copy-doa {\n  width: 13px;\n}\n\n.icon-share-doa {\n  margin-right: 20px;\n  width: 15px;\n}\n\n.icon-back-doa1 {\n  margin-right: 15px;\n  width: 20px;\n}\n\n.icon-back-doa {\n  width: 20px;\n  margin-right: 15px;\n}\n\n.rig-details-panel {\n  background-color: rgba(0, 0, 0, 0.1);\n  width: 1150px;\n  height: 900px;\n  margin-left: 20px;\n  margin-top: 15px;\n}\n\n.rig-details {\n  padding-top: 20px;\n  padding-bottom: 10px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.rig-details-box {\n  background-color: rgba(39, 40, 75, 1);\n  color: aliceblue;\n  font-family: 'Graphik';\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 10px;\n  border: 1px solid rgba(116, 123, 169, 1);\n  /* margin: 0px 10px 10px 5px; */\n  border-radius: 10px;\n}\n\n\n.rig-details-box::-webkit-scrollbar {\n  width: 5px;\n}\n\n.rig-details-box::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n}\n\n/* .rig-details-box::-webkit-scrollbar-track-piece{\n  height: 50px;\n\n} */\n\n.rig-details-header {\n  background-color: rgba(60, 64, 105, 1);\n  border-bottom: 1px solid rgba(87, 95, 142, 1);\n  color: aliceblue;\n  font-family: 'Graphik';\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 10px;\n  height: 30px;\n  padding: 10px;\n  margin-left: -12px;\n  margin-right: -12px;\n  border-top-right-radius: 10px;\n  border-top-left-radius: 10px;\n  margin-bottom: 10px;\n}\n\n.flex-cont {\n  display: flex;\n}\n\n\n\n.flex-cont-row {\n  display: flex;\n  flex-direction: column;\n}\n\n.rig-details-body {\n  color: aliceblue;\n  font-family: 'Graphik';\n  font-weight: 300;\n  font-size: 11px;\n  line-height: 5px;\n}\n\n\n.custom-file-upload {\n  display: inline-block;\n  position: relative;\n  font-family: Arial, sans-serif;\n  /* overflow: hidden; */\n  margin-right: 4px;\n  margin-top: 10px;\n}\n\n.custom-file-upload input[type=\"file\"] {\n  font-size: 100px;\n  position: absolute;\n  left: 0;\n  top: 0;\n  opacity: 0;\n}\n\n.custom-file-upload span {\n  padding: 6px 12px;\n  cursor: pointer;\n  border-radius: 10px;\n  border: 1px solid rgba(116, 123, 169, 1);\n  color: rgba(255, 255, 255, 1);\n  width: 100px;\n  height: 40px;\n  margin-left: 60px;\n  background-color: rgba(116, 123, 169, 0.3);\n}\n\n.custom-file-upload:hover span {\n  background: rgba(116, 123, 169, 1);\n}\n\n.upload-button {\n  border-radius: 10px;\n  border: 1px solid rgba(116, 123, 169, 1);\n  color: rgba(255, 255, 255, 1);\n  /* width:100px;\n  height:40px; */\n  margin-left: 60px;\n  background-color: rgba(116, 123, 169, 0.3);\n}\n\n.loader-c {\n  display: flex;\n  margin-left: 150px;\n  justify-content: center;\n  align-items: center;\n  height: 40px;\n}\n\n.dot-cq-doa {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  display: inline-block;\n  animation: bounce 1.4s infinite ease-in-out;\n}\n\n.red-c-doa {\n  background-color: red;\n  animation-delay: -0.32s;\n}\n\n.green-c-doa {\n  background-color: green;\n  animation-delay: -0.16s;\n}\n\n.blue-c-doa {\n  background-color: blue;\n\n}\n\n.tick-circle {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  background-color: green;\n  position: relative;\n  top: 10%;\n  left: 4%;\n}\n\n.tick-circle::before {\n  content: '\\2713';\n  /* Unicode character for a checkmark */\n  font-size: 10px;\n  color: white;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.table-doa1 {\n  border-collapse: collapse;\n  border: 1px solid rgba(87, 95, 142, 1);\n  border-radius: 20px;\n  /* width: 100%; */\n}\n\n.table-doa1 th {\n  border: 1px solid #575F8E;\n  padding: 20px;\n  text-align: center;\n  background-color: #3C4069;\n  width: fit-content;\n}\n\n.table-doa1 td {\n  border: 1px solid #575F8E;\n  padding: 8px;\n  text-align: left;\n}\n\n.table-doa1 tr {\n  width: 100%;\n}\n\n.table-doa1 tbody tr:hover {\n  background-color: rgba(87, 95, 142, 0.452);\n  /* Custom color for hover effect */\n}\n\n.even-row {\n  background-color: #27284B\n}\n\n.odd-row {\n  background-color: #202342\n}\n\n/* @media (max-width: 600px) {\n    .table-doa1 th,\n    .table-doa1 td {\n      display: block;\n      width: 100%;\n      box-sizing: border-box;\n    }\n  } */\n.search-rig {\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 5px;\n  border-color: #8d97dac5;\n  height: 30px;\n  width: 270px;\n  background-color: transparent;\n  margin-top: 17px;\n  margin-right: 15px;\n  color: #FFFFFF;\n  font-size: 13px;\n  font-weight: 400;\n  padding-left: 5px;\n}\n\n.search-rig::placeholder {\n  color: #FFFFFF;\n  font-size: 13px;\n  font-weight: 400;\n  padding: 5px;\n}\n\n.search-rig:focus {\n  outline: none;\n}\n.search-dd {\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 5px;\n  border-color: #8d97dac5;\n  height: 30px;\n  width: 270px;\n  background-color: transparent;\n  margin-left: 90%;\n  margin-top: 17px;\n  color: #FFFFFF;\n  font-size: 13px;\n  font-weight: 400;\n  padding-left: 5px;\n}\n\n.search-dd::placeholder {\n  color: #FFFFFF;\n  font-size: 13px;\n  font-weight: 400;\n  padding: 5px;\n}\n\n.search-dd:focus {\n  outline: none;\n}\n\n.status-dd {\n  border-style: solid;\n  border-width: 1px;\n  border-radius: 5px;\n  border-color: #8d97dac5;\n  height: 30px;\n  width: 170px;\n  background-color: transparent;\n  margin-left: 13px;\n  margin-top: 17px;\n  color: #FFFFFF;\n  font-size: 13px;\n  font-weight: 400;\n  padding-left: 5px;\n}\n\n.status-dd::placeholder {\n  color: #FFFFFF;\n  font-size: 13px;\n  font-weight: 400;\n  padding: 10px 5px;\n}\n\n.status-dd:focus {\n  outline: none;\n}\n\n.status-dd option {\n  color: white;\n  background-color: #3C4069;\n  border: 1px solid #747BA9;\n  font-size: 12px;\n  font-family: Graphik;\n  font-weight: 400;\n}\n\nselect option [disabled] {\n  color: black;\n  font-size: 12px;\n  font-family: Graphik;\n  font-weight: 400;\n}\n\n.icon-input {\n  position: relative;\n}\n\n.icon-input input {\n  padding-left: 30px;\n}\n\n.icon12 {\n  position: absolute;\n  left: 20px;\n  top: 45%;\n  transform: translateY(-50%);\n}\n\n.icon12-rig {\n  position: absolute;\n  left: 10px;\n  top: 45%;\n  transform: translateY(-50%);\n}\n\n.icon123 {\n  position: absolute;\n  left: 92%;\n  top: 45%;\n  transform: translateY(-50%);\n}\n\n.datepicker {\n  padding-left: 40px;\n}\n\n.rig-panel-top {\n  display: flex;\n  margin-left: 10px;\n}\n\n.rig-details-panel-top {\n  margin-left: 15px;\n}\n\n.icon-drilling-button{\n  width: 20px;\n  margin-right: 15px;\n}\n\n.date-rig{\n  width: fit-content;\n  padding: 5px;\n  color: #FFFFFF;\n  font-family: Graphik;\n  font-size: 12px;\n  font-weight: 355;\n  border-radius: 5px;\n  border: 1px solid #747BA9;\n  margin-right: 15px;\n  margin-top: 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
